import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import App from './App';
import { ThemeProvider } from '@/contexts/ThemeContext';
import './index.css';

// Configure Amplify
const cognitoDomain = import.meta.env.VITE_COGNITO_DOMAIN || `${import.meta.env.VITE_USER_POOL_ID}.auth.${import.meta.env.VITE_REGION}.amazoncognito.com`;

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_USER_POOL_ID as string,
      userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID as string,
      loginWith: {
        email: true,
        oauth: cognitoDomain ? {
          domain: cognitoDomain,
          scopes: ['email', 'profile', 'openid'],
          redirectSignIn: [window.location.origin],
          redirectSignOut: [window.location.origin],
          responseType: 'code',
        } : undefined,
      },
      signUpVerificationMethod: 'code',
      userAttributes: {
        email: {
          required: true,
        },
      },
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
